import { useEffect, useState } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import jwtDecode from "jwt-decode";
import ProtectedRoutes from "./ProtectedRoutes/ProtectedRoutes";
import ScrollToTop from "./common/scrollToTop";

//Static Pages Imports
import HomePage from "./components/pages";
import About from "./components/pages/about";
import Mortgage from "./components/pages/Mortgage";
import LookingBack from "./components/pages/LookingBack";

import Privacy from "./components/pages/privacy.jsx";
import TermsAndCondition from "./components/pages/termsAndCondition.jsx";
import Attorneys from "./components/pages/attorneys";
import Faq from "./components/pages/faq";
import PageNotFound from "./components/pages/pagenotfound";
import CongratulationMessage from "./components/pages/congratulationMessage";

//User Imports
import Login from "./components/dashBoardPages/login";
import CreditCounseling from "./components/pages/creditCounseling";
import DashboardPage from "./components/pages/dashboardPage";
import DashboardSuccess from "./components/pages/dashboardPage-Success";
import JointFilerInfo from "./components/pages/jointFiler-info";
import PaymentPage from "./components/pages/paymentPage";
import RegistrationPage from "./components/pages/registrationPage";
import UserProfileUpdate from "./components/pages/userProfileUpdate";
import UserProfile from "./components/pages/userProfile";
import EnrollmentInFirstCourse from "./components/pages/enrollment-in-First-course";
import SetUpAttorneyAccountUser from "./components/pages/Set-up-Attorney-Account";
import HowDidThisHappen from "./components/pages/how-did-this-happen";
import CourseReviewQuestion from "./components/pages/course-review-question";
import CourseSurvey from "./components/pages/course-survey";
import NetWorthStepper from "./components/pages/net-worth-stepper";
import ResetPassword from "./components/pages/reset-password";
import ForgotPassword from "./components/pages/forgotPassword";
import SpendingPlan from "./components/pages/spending-plan";
import EnrollmentIn2ndCourse from "./components/pages/enrollment-in-2nd-course";
import ReportAnIssue from "./components/pages/reportAnIssue";
import Course2 from "./components/pages/course2";
import SecurityQuestion from "./components/pages/security-question";
import BudgetAnalysis from "./components/pages/budget-analysis";
import BudgetAnalysisIncome from "./components/pages/budget-analysis-income";
import BudgetAnalysisExpenses from "./components/pages/budget-analysis-expenses";
import BudgetAnalysisDebts from "./components/pages/budget-analysis-debts";
import LocateCertificates from "./components/pages/locate-certificates";
import RequestClientCards from "./components/pages/request-client-cards";
import AddInfoMultistep from "./components/dashBoardPages/add-info-multistep";
import CertificateToCourt from "./components/dashBoardPages/certificate-to-court.jsx";
import ContactWithCounselor from "./components/pages/contactwithcounselor.jsx";
import LanguageRequestForm from "./components/pages/language-request-form.jsx";

// Dashboard Imports
import Dashboard from "./components/dashBoardPages/dashboard";
import ManageStudents from "./components/dashBoardPages/manage-students";
import ManageAttorney from "./components/dashBoardPages/manage-attorney.jsx";
import AttorneyClients from "./components/dashBoardPages/attorney-clients.jsx";
import EditAttorney from "./components/dashBoardPages/edit-attorney.jsx";
import EditingClient from "./components/dashBoardPages/editing-client";
import GladeClientDetails from "./components/dashBoardPages/glade-client-details";
import GladeCourseProgress from "./components/dashBoardPages/glade-course-progress";
import GladeBudgetAnalysisAdminEdit from "./components/dashBoardPages/GladeBudgetAnalysisAdminEdit";
import GladeBudgetAnalysisAdminSection from "./components/dashBoardPages/GladeBudgetAnalysisAdminSection";
import CoursePrograme from "./components/dashBoardPages/course-programe";
import AddInfoMultistepAdmin from "./components/dashBoardPages/add-info-multistep";
import BudgetAnalysisAdmin from "./components/dashBoardPages/budget-analysis";
import BudgetAnalysisIncomeAdmin from "./components/dashBoardPages/budget-analysis-income";
import BudgetAnalysisExpensesAdmin from "./components/dashBoardPages/budget-analysis-expenses";
import BudgetAnalysisDebtsAdmin from "./components/dashBoardPages/budget-analysis-debts";
import EditMyAccount from "./components/dashBoardPages/edit-my-account";
import SetUpUserAccount from "./components/dashBoardPages/set-up-user-account";
import SetUpAttorneyAccountAdmin from "./components/dashBoardPages/set-up-attorney-account";
import LanguageRequests from "./components/dashBoardPages/language-requests";
import AttorneyEmailAddress from "./components/dashBoardPages/attorney-email-address";
import ManageCouponCodes from "./components/dashBoardPages/manage-coupon-codes";
import PendingBilling1stcourse from "./components/dashBoardPages/Pending-Billing(1s-course)";
import PendingBilling2ndcourse from "./components/dashBoardPages/Pending-Billing(2s-course)";
import EvaluationStats1stCourse from "./components/dashBoardPages/Evaluation-Stats(1st-course)";
import EvaluationStats2ndCourse from "./components/dashBoardPages/Evaluation-Stats(2st-course)";
import EnrollmentStats1stCourse from "./components/dashBoardPages/Enrollment-Stats(1st-Course)";
import TrainingAndHowTo from "./components/dashBoardPages/training-and-how-to";
import DashboardCourse from "./components/dashBoardPages/dashboardcourse";
import EvergreenCourse from "./components/pages/evergreen-course";
import ClientCardsOrders from "./components/dashBoardPages/client-cards-orders";
import Certificates from "./components/dashBoardPages/certificates";
import Followup from "./components/dashBoardPages/followup";
import Booklets from "./components/dashBoardPages/booklets";

// Attorney Imports
import ManageClients from "./components/attorneyDashboardPages/manage-clients";
import EditAttorneyAccount from "./components/attorneyDashboardPages/edit-attorney-account";
import AttoneyCardRequest from "./components/attorneyDashboardPages/attoney-card-request";
import AttorneyIssueReport from "./components/attorneyDashboardPages/attorney-issue-report";
import MakeSuggestion from "./components/attorneyDashboardPages/make-suggestion";
import LeaveTestimonial from "./components/attorneyDashboardPages/leave-testimonial";
import PrintableInfoSheets from "./components/attorneyDashboardPages/printable-info-sheets";

import "./App.css";
import "./assets/css/bootstrap.min.css";
import "./assets/css/style.css";
import "./assets/css/responsive.css";
import "./assets/js/bootstrap.min.js";
import Course3 from "./components/pages/course3.jsx";
import CompleteReport from "./components/dashBoardPages/CompleteReport.jsx";
import AttorneySignupSuccess from "./components/pages/attorneySignupSuccess.jsx";
import languageIcon from './assets/images/languageicon.png'
import CrpPrivacyPolicy from "./components/pages/CrpPrivacyPolicy.jsx";
import Creditrebuilder from "./components/pages/creditrebuilder.jsx";
import Financialeducation from "./components/pages/financialeducation.jsx";
import BeforeContactWithCounselor from "./components/pages/BeforeContactwithcounselor.jsx";
import Crpfaqs from "./components/pages/crpfaqs.jsx";
import Resources from "./components/pages/resources.jsx";
import ManageStaff from "./components/dashBoardPages/ManageStaff.jsx";
import AttorneyPendingBilling1stcourse from "./components/dashBoardPages/AttorneyPendingBilling1stcourse.jsx";
import AttorneyPendingBilling2ndcourse from "./components/dashBoardPages/AttorneyPendingBilling2ndcourse.jsx";
import AttorneyInvoiceHistory from "./components/dashBoardPages/AttorneyInvoiceHistory.jsx";
import FreeWaiverReport from "./components/dashBoardPages/FreeWaiverReport .jsx";
import LanguageReport from "./components/dashBoardPages/LanguageReport.jsx";
import PhoneCourseReport from "./components/dashBoardPages/PhoneCourseReport.jsx";
import AttorneyPendingBilling from "./components/dashBoardPages/AttorneyPendingBilling.jsx";
// import InvoiceModal from "./components/dashBoardPages/InvoiceModal.jsx";
import InvoiceMOdalComponent from "./components/dashBoardPages/InvoiceModalComponent.jsx";
import GladeBilling from "./components/dashBoardPages/GladeBilling.jsx";
import GladeInvoiceHistory from "./components/dashBoardPages/GladeInvoiceHistory.jsx";
import CertificateIssued from "./components/dashBoardPages/CertificateIssued.jsx";
import RetakeReport from "./components/dashBoardPages/RetakeReport.jsx";
import CCLatestCourse from "./components/pages/Cclatestcourse.jsx";
import SurveyReport from "./components/dashBoardPages/SurveyReport.jsx";
import ArchiveClients from "./components/attorneyDashboardPages/ArchiveClients.jsx";
import CourseAccess from "./components/GlapApi/CourseAccess.jsx";
import HowDidThisHappenForThirdParty from "./components/pages/HowDidThisHappenForThirdParty.jsx";
import AddInfoMultistepThirdParty from "./components/pages/AddInfoMultistepThirdParty.jsx";
import CourseReviewQuestionForThirdParty from "./components/pages/CourseReviewQuestionForThirdParty.jsx";

function App() {
  const publicRoutes = ["/forgot-password", "/reset-password","/locate-certificates", "/lookingback", "/lookingback/"];
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const AttorneyCode = queryParams.get("code");
  const isTokenExpired = (token) => {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decodedToken.exp < currentTime;
  };
  const [authChecked, setAuthChecked] = useState(false);
  const isTokenValid = (token) => {
  try {
    const decoded = jwtDecode(token);

    // must have exp
    if (!decoded?.exp) return false;

    // optional: verify issuer / audience if backend sets it
    // if (decoded.iss !== "your-api-name") return false;

    const currentTime = Date.now() / 1000;
    return decoded.exp > currentTime;
  } catch (err) {
    return false;
  }
};
useEffect(() => {
  const token = localStorage.getItem("token");
const isThirdPartyRoute =
  location.pathname.startsWith("/course1/") ||
  location.pathname.startsWith("/course2/") ||
  location.pathname.startsWith("how-did-this-happen") ;

  if (!token || !isTokenValid(token)) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("isLoggedIn");
    setAuthChecked(true);
    if (!publicRoutes.includes(location.pathname) && !isThirdPartyRoute ) {
      if (AttorneyCode) {
        navigate(`/login?code=${AttorneyCode}`, { replace: false });

      } else {
        navigate("/login", { replace: false });

      }
    }
    return;
    // setAuthChecked(true);
    // return;
  }

  setAuthChecked(true);
}, []);

  // useEffect(() => {
  //   const token = localStorage.getItem("token");
  //   console.log("Token in App.js:", token);
  //   if (token && isTokenExpired(token)) {
  //     localStorage.removeItem("token");
  //     localStorage.removeItem("user");
  //     localStorage.removeItem("isLoggedIn");
  //     navigate("/login");
  //   }
  // }, []);

  // const googleTranslateElementInit = () => {
  //   new window.google.translate.TranslateElement(
  //     {
  //       pageLanguage: "en",
  //       autoDisplay: false,
  //     },
  //     "google_translate_element"
  //   );
  // };

  // useEffect(() => {
  //   var addScript = document.createElement("script");
  //   addScript.setAttribute(
  //     "src",
  //     "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
  //   );
  //   document.body.appendChild(addScript);
  //   window.googleTranslateElementInit = googleTranslateElementInit;

  //   // Add CSS to hide Google Translate top bar and loading elements
  //   const style = document.createElement("style");
  //   style.innerHTML = `
  //     body > .skiptranslate,
  //     #goog-gt-tt,  /* Hides tooltip */
  //     .goog-te-spinner-pos,  /* Hides loading spinner */
  //     iframe.goog-te-banner-frame,
  //     .goog-te-balloon-frame {
  //       display: none !important;
  //     }
  //     body {
  //       top: 0px !important;
  //     }
  //   `;
  //   document.head.appendChild(style);


  // }, []);
if (!authChecked) return null;

  return (
    (
      // (localStorage.getItem("token") &&
      // !isTokenExpired(localStorage.getItem("token"))) ||
      // !localStorage.getItem("token")) && (
      
      
      <div className="App">
        <ScrollToTop />

        {/* <div
        className="google-translate-container"
      style={{
        position: "fixed",
        right: "0px",
        top: "20px",
        // zIndex: 999999,
        display: "flex",
        alignItems: "center",
        // cursor: "pointer",
        zIndex:'99991'
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
   
   <img
      src={languageIcon}
      alt="Language Icon"
      style={{
        color: "#333",
        backgroundColor: isHovered ? '#508E45' : '#508E45', 
        borderRadius: '50%',
        padding: '10px',
        height: "56px",
        width: "56px",
        transition: 'background-color 0.3s ease, box-shadow 0.25s ease-in-out, filter 0.25s ease-in-out',
        boxShadow: isHovered ? 'rgba(0, 0, 0, 0.38) 0px 4px 12px' : 'none',
        filter: isHovered ? 'brightness(125%)' : 'none',
      }}
     
    />
     
      <div
        id="google_translate_element"
        className="language-icon"
        style={{
          opacity: 0, 
          position: "fixed",
          right: "0px",
          top: "20px",
          overflow:'hidden',
          height: "57px",
          width: "60px",
        
        }}
      ></div>
    </div> */}
        <Routes>
          {/* Static Routes */}
          <Route exact path="/" element={<HomePage />} />
          <Route path="/lookingback" element={<LookingBack />} />
          {/* <Route path="/about" element={<About />} /> */}
          <Route path="/mortgage" element={<Mortgage />} />
          {/* <Route path="/creditrebuilder" element={<Creditrebuilder />} /> */}
          {/* <Route path="/privacy-policy" element={<Privacy />} /> */}
          {/* <Route path="/crp-privacy-policy" element={<CrpPrivacyPolicy />} /> */}
          {/* <Route path="/crpfaqs" element={<Crpfaqs />} /> */}
          {/* <Route path="/resources" element={<Resources />} /> */}

          {/* <Route path="/terms-and-condition" element={<TermsAndCondition />} /> */}
          {/* <Route path="/faq" element={<Faq />} /> */}
          {/* <Route path="/attorneys" element={<Attorneys />} /> */}
          <Route
            path="/course1/budget-analysis/:clientId"
            element={<CourseAccess course="CC_BUDGET" />}
          />
          <Route
            path="/course1/budget-analysis-summary/:clientId"
            element={<CourseAccess course="CC_BUDGET_SUMMARY_OVERVIEW" />}
          />
          <Route
            path="/course1/budget-analysis-summary/:clientId/income"
            element={<CourseAccess course="CC_BUDGET_SUMMARY_INCOME" />}
          />
          <Route
            path="/course1/budget-analysis-summary/:clientId/expenses"
            element={<CourseAccess course="CC_BUDGET_SUMMARY_EXPENSES" />}
          />
          <Route
            path="/course1/budget-analysis-summary/:clientId/debts"
            element={<CourseAccess course="CC_BUDGET_SUMMARY_DEBTS" />}
          />
          <Route path="/course1/:clientId" element={<CourseAccess course="CC" />} />
          <Route path="/course2/:clientId" element={<CourseAccess course="DE" />} />
          <Route
            path="/course1/how-did-this-happen/:clientId"
            element={
              <HowDidThisHappenForThirdParty />
            }
          />
          <Route
            path="/how-did-this-happen-for-third-party/:clientId"
            element={
              <HowDidThisHappenForThirdParty />
            }
          />

          <Route
            path="/review-questions/:clientId"
            element={
              <CourseReviewQuestionForThirdParty />
            }
          />
          <Route
            path="/congratulationmessage"
            element={<CongratulationMessage />}
          />
          {/* <Route
            path="/beforecontactwithcounselor"
            element={<BeforeContactWithCounselor />}
          /> */}
          <Route
            path="/beforecontactwithcounselor"
            element={
              // <ProtectedRoutes role="User" login={true} component={<BeforeContactWithCounselor />} />
          <ProtectedRoutes role={["User", "Admin"]} login={true} component={<BeforeContactWithCounselor />} />

            }
          />
          
          <Route
            path="/contactwithcounselor"
            element={<ContactWithCounselor />}
          />
          <Route path="*" element={<PageNotFound />} />

          {/* Auth/Misc. Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/registration" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/setup-attorney-account"
            element={<SetUpAttorneyAccountUser />}
          />
          <Route
            path="/attorney-account-success"
            element={<AttorneySignupSuccess />}
          />
          <Route path="/locate-certificates" element={<LocateCertificates />} />
          <Route
            path="/request-client-cards"
            element={<RequestClientCards />}
          />
          <Route path="/report-an-issue" element={<ReportAnIssue />} />
          <Route path="/financialeducation" element={<Financialeducation />} />

          {/* User Routes */}

          <Route
            path="/dashboard"
            element={
              <ProtectedRoutes role="User" component={<DashboardPage />} />
            }
          />
          <Route
            path="/userprofile"
            element={
              <ProtectedRoutes role="User" component={<UserProfile />} />
            }
          />
          <Route
            path="/enrollmentinfirstcourse"
            element={
              <ProtectedRoutes
                role="User"
                component={<EnrollmentInFirstCourse />}
              />
            }
          />
          <Route
            path="/enrollmentin2ndcourse"
            element={
              <ProtectedRoutes
                role="User"
                component={<EnrollmentIn2ndCourse />}
              />
            }
          />
          <Route
            path="/security-law-questions"
            element={
              <ProtectedRoutes role="User" component={<SecurityQuestion />} />
            }
          />
          <Route
            path="/course"
            // element={<ProtectedRoutes role="User" component={<Course />} />}
            element={<ProtectedRoutes role="User" component={<CCLatestCourse />} />}

          />
          <Route
            path="/2nd-course"
            element={<ProtectedRoutes role="User" component={<Course2 />} />}
          />
          {/* <Route path="/720course" element={<Course3 />} /> */}
          <Route
            path="/add-info-multistep"
            element={
              <ProtectedRoutes role="User" component={<AddInfoMultistep />} />
            }
          />

          <Route
            path="/budget-analysis"
            element={
              <ProtectedRoutes role="User" component={<BudgetAnalysis />} />
            }
          />
          <Route
            path="/budget-analysis-income"
            element={
              <ProtectedRoutes
                role="User"
                component={<BudgetAnalysisIncome />}
              />
            }
          />
          <Route
            path="/budget-analysis-debts"
            element={
              <ProtectedRoutes
                role="User"
                component={<BudgetAnalysisDebts />}
              />
            }
          />
          <Route
            path="/budget-analysis-expenses"
            element={
              <ProtectedRoutes
                role="User"
                component={<BudgetAnalysisExpenses />}
              />
            }
          />
          <Route
            path="/how-did-this-happen"
            element={
              <ProtectedRoutes role="User" component={<HowDidThisHappen />} />
            }
          />
          <Route
            path="/net-worth"
            element={
              <ProtectedRoutes role="User" component={<NetWorthStepper />} />
            }
          />
          <Route
            path="/spending-plan"
            element={
              <ProtectedRoutes role="User" component={<SpendingPlan />} />
            }
          />
          <Route
            path="/course-survey"
            element={
              <ProtectedRoutes role="User" component={<CourseSurvey />} />
            }
          />
          <Route
            path="/review-questions"
            element={
              <ProtectedRoutes
                role="User"
                component={<CourseReviewQuestion />}
              />
            }
          />
          <Route
            path="/creditcounseling"
            element={
              <ProtectedRoutes role="User" component={<CreditCounseling />} />
            }
          />
          <Route
            path="/dashboardsuccess"
            element={
              <ProtectedRoutes role="User" component={<DashboardSuccess />} />
            }
          />
          <Route
            path="/jointfilerinfo"
            element={
              <ProtectedRoutes role="User" component={<JointFilerInfo />} />
            }
          />
          <Route
            path="/paymentpage"
            element={
              <ProtectedRoutes role="User" component={<PaymentPage />} />
            }
          />
          <Route
            path="/userprofileupdate"
            element={
              <ProtectedRoutes role="User" component={<UserProfileUpdate />} />
            }
          />
          <Route
            path="/addinfomultistep"
            element={
              <ProtectedRoutes role="User" component={<AddInfoMultistep />} />
            }
          />

          <Route
            path="/request-language"
            element={
              <ProtectedRoutes
                role="User"
                component={<LanguageRequestForm />}
              />
            }
          />

          {/* Attorney Routes */}
          <Route
            path="/manage-clients"
            element={
              <ProtectedRoutes role="Atty" component={<ManageClients />} />
            }
          />
          <Route
            path="/archive-clients"
            element={
              <ProtectedRoutes role="Atty" component={<ArchiveClients />} />
            }
          />
          <Route
            path="/edit-attorney-account"
            element={
              <ProtectedRoutes
                role="Atty"
                component={<EditAttorneyAccount />}
              />
            }
          />
          <Route
            path="/attoney-card-request"
            element={
              <ProtectedRoutes role="Atty" component={<AttoneyCardRequest />} />
            }
          />
          <Route
            path="/attorney-issue-report"
            element={
              <ProtectedRoutes
                role="Atty"
                component={<AttorneyIssueReport />}
              />
            }
          />
          <Route
            path="/make-suggestion"
            element={
              <ProtectedRoutes role="Atty" component={<MakeSuggestion />} />
            }
          />
          <Route
            path="/leave-testimonial"
            element={
              <ProtectedRoutes role="Atty" component={<LeaveTestimonial />} />
            }
          />
          <Route
            path="/printable-info-sheets"
            element={
              <ProtectedRoutes
                role="Atty"
                component={<PrintableInfoSheets />}
              />
            }
          />

          {/* Dashboard Routes */}
          <Route
            path="/admin-dashboard"
            element={<ProtectedRoutes role="Admin" component={<Dashboard />} />}
          />
          <Route
            path="/managestudents"
            element={
              <ProtectedRoutes role="Admin" component={<ManageStudents />} />
            }
          />
          <Route
            path="/manageattorney"
            element={
              <ProtectedRoutes role="Admin" component={<ManageAttorney />} />
            }
          />
          <Route
            path="/managestaff"
            element={
              <ProtectedRoutes role="Admin" component={<ManageStaff />} />
            }
          />
          <Route
            path="/attorney-clients"
            element={
              <ProtectedRoutes role="Admin" component={<AttorneyClients />} />
            }
          />
          <Route
            path="/edit-attorney"
            element={
              <ProtectedRoutes role="Admin" component={<EditAttorney />} />
            }
          />
          <Route
            path="/editstudent"
            element={
              <ProtectedRoutes role="Admin" component={<EditingClient />} />
            }
          />
          <Route
            path="/glade-client-details"
            element={
              <ProtectedRoutes role="Admin" component={<GladeClientDetails />} />
            }
          />
          <Route
            path="/glade-course-progress"
            element={
              <ProtectedRoutes role="Admin" component={<GladeCourseProgress />} />
            }
          />
          <Route
            path="/glade-budget-analysis-report"
            element={
              <ProtectedRoutes
                role="Admin"
                component={<GladeBudgetAnalysisAdminSection />}
              />
            }
          />
          <Route
            path="/glade-budget-analysis-edit"
            element={
              <ProtectedRoutes
                role="Admin"
                component={<GladeBudgetAnalysisAdminEdit />}
              />
            }
          />
          <Route
            path="/certificate-to-court"
            element={
              <ProtectedRoutes
                role="Admin"
                component={<CertificateToCourt />}
              />
            }
          />
          <Route
            path="/courseprogress"
            element={
              <ProtectedRoutes role="Admin" component={<CoursePrograme />} />
            }
          />
          <Route
            path="/enroll-user-first-course"
            element={
              <ProtectedRoutes
                role="Admin"
                component={<EnrollmentInFirstCourse />}
              />
            }
          />
          <Route
            path="/enroll-user-second-course"
            element={
              <ProtectedRoutes
                role="Admin"
                component={<EnrollmentIn2ndCourse />}
              />
            }
          />
          <Route
            path="/spending-plan-user"
            element={
              <ProtectedRoutes role="Admin" component={<SpendingPlan />} />
            }
          />
          <Route
            path="/user-dashboard-page"
            element={
              <ProtectedRoutes role="Admin" component={<DashboardPage />} />
            }
          />
          <Route
            path="/user-first-course"
            element={
              <ProtectedRoutes role="Admin" component={<CCLatestCourse />} />
            }
          />
          <Route
            path="/user-second-course"
            element={<ProtectedRoutes role="Admin" component={<Course2 />} />}
          />
          <Route
            path="/addinfomultistepuser"
            element={
              <ProtectedRoutes
                role="Admin"
                component={<AddInfoMultistepAdmin />}
              />
            }
          />
          <Route
            path="/how-did-this-happen-user"
            element={
              <ProtectedRoutes role="Admin" component={<HowDidThisHappen />} />
            }
          />
          <Route
            path="/net-worth-user"
            element={
              <ProtectedRoutes role="Admin" component={<NetWorthStepper />} />
            }
          />
          <Route
            path="/course-survey-user"
            element={
              <ProtectedRoutes role="Admin" component={<CourseSurvey />} />
            }
          />
          <Route
            path="/review-questions-user"
            element={
              <ProtectedRoutes
                role="Admin"
                component={<CourseReviewQuestion />}
              />
            }
          />
          <Route
            path="/budget-analysis-report"
            element={
              <ProtectedRoutes
                role="Admin"
                component={<BudgetAnalysisAdmin />}
              />
            }
          />
          <Route
            path="/income-analysis"
            element={
              <ProtectedRoutes
                role="Admin"
                component={<BudgetAnalysisIncomeAdmin />}
              />
            }
          />
          <Route
            path="/expenses-analysis"
            element={
              <ProtectedRoutes
                role="Admin"
                component={<BudgetAnalysisExpensesAdmin />}
              />
            }
          />
          <Route
            path="/debts-analysis"
            element={
              <ProtectedRoutes
                role="Admin"
                component={<BudgetAnalysisDebtsAdmin />}
              />
            }
          />
          <Route
            path="/editmyaccount"
            element={
              <ProtectedRoutes role="Admin" component={<EditMyAccount />} />
            }
          />
          <Route
            path="/setupuseraccount"
            element={
              <ProtectedRoutes role="Admin" component={<SetUpUserAccount />} />
            }
          />
          <Route
            path="/setupattorneyaccount"
            element={
              <ProtectedRoutes
                role="Admin"
                component={<SetUpAttorneyAccountAdmin />}
              />
            }
          />
          <Route
            path="/trainingandhowto"
            element={
              <ProtectedRoutes role="Admin" component={<TrainingAndHowTo />} />
            }
          />
          <Route
            path="/languagerequests"
            element={
              <ProtectedRoutes role="Admin" component={<LanguageRequests />} />
            }
          />
          <Route
            path="/attorneyemailaddress"
            element={
              <ProtectedRoutes
                role="Admin"
                component={<AttorneyEmailAddress />}
              />
            }
          />
          <Route
            path="/managecouponcodes"
            element={
              <ProtectedRoutes role="Admin" component={<ManageCouponCodes />} />
            }
          />
          <Route
            path="/pendingbilling1stcourse"
            element={
              <ProtectedRoutes
                role="Admin"
                component={<PendingBilling1stcourse />}
              />
            }
          />
          <Route
            path="/pendingbilling2ndcourse"
            element={
              <ProtectedRoutes
                role="Admin"
                component={<PendingBilling2ndcourse />}
              />
            }
          />
          <Route
            path="/evaluationstats1stcourse"
            element={
              <ProtectedRoutes
                role="Admin"
                component={<EvaluationStats1stCourse />}
              />
            }
          />
           {/* <Route
            path="/attorneypendingbilling1stcourse"
            element={
              <ProtectedRoutes
                role="Admin"
                component={ <AttorneyPendingBilling1stcourse />}
              />
            }
          /> */}
           <Route
            path="/attorneypendingbilling"
            element={
              <ProtectedRoutes
                role="Admin"
                component={ <AttorneyPendingBilling />}
              />
            }
          />
           <Route
            path="/invoice"
            element={
              <ProtectedRoutes
                role="Admin"
                component={ <InvoiceMOdalComponent />}
              />
            }
          />
           {/* <Route
            path="/attorneypendingbilling2ndcourse"
            element={
              <ProtectedRoutes
                role="Admin"
                component={<AttorneyPendingBilling2ndcourse />}
              />
            }
          /> */}
           <Route
             path="/attorneyinvoicehistory"
            element={
              <ProtectedRoutes
                role="Admin"
                component={<AttorneyInvoiceHistory />}
              />
            }
           />
           <Route
             path="/gladebilling"
             element={
               <ProtectedRoutes role="Admin" component={<GladeBilling />} />
             }
           />
           <Route
             path="/gladeinvoicehistory"
             element={
               <ProtectedRoutes role="Admin" component={<GladeInvoiceHistory />} />
             }
           />
           <Route
            path="/completionreport"
            element={
              <ProtectedRoutes role="Admin" component={<CompleteReport />} />
            }
          />
           <Route
            path="/freewavierreport"
            element={
              <ProtectedRoutes role="Admin" component={<FreeWaiverReport />} />
            }
          />
          <Route
            path="/languagereport"
            element={
              <ProtectedRoutes role="Admin" component={<LanguageReport />} />
            }
          />
          <Route
            path="/surveyreport"
            element={
              <ProtectedRoutes role="Admin" component={<SurveyReport />} />
            }
          />
            <Route
            path="/retakereport"
            element={
              <ProtectedRoutes role="Admin" component={<RetakeReport />} />
            }
          />
          <Route
            path="/certificate-issued"
            element={
              <ProtectedRoutes role="Admin" component={<CertificateIssued />} />
            }
          />
           {/* <Route
            path="/phonecoursereport"
            element={
              <ProtectedRoutes role="Admin" component={<PhoneCourseReport />} />
            }
          /> */}
          <Route
            path="/evaluationstats2ndcourse"
            element={
              <ProtectedRoutes
                role="Admin"
                component={<AttorneyPendingBilling1stcourse />}
              />
            }
          />
          <Route
            path="/enrollmentstats1stcourse"
            element={
              <ProtectedRoutes
                role="Admin"
                component={<AttorneyPendingBilling2ndcourse />}
              />
            }
          />
          <Route
            path="/dashboardcourse"
            element={
              <ProtectedRoutes role="Admin" component={<DashboardCourse />} />
            }
          />
          <Route
            path="/evergreencourse"
            element={
              <ProtectedRoutes role="Admin" component={<EvergreenCourse />} />
            }
          />
          <Route
            path="/booklets"
            element={<ProtectedRoutes role="Admin" component={<Booklets />} />}
          />
          <Route
            path="/clientcardsorders"
            element={
              <ProtectedRoutes role="Admin" component={<ClientCardsOrders />} />
            }
          />
          <Route
            path="/certificates"
            element={
              <ProtectedRoutes role="Admin" component={<Certificates />} />
            }
          />
          <Route
            path="/followup"
            element={<ProtectedRoutes role="Admin" component={<Followup />} />}
          />
          <Route
            path="/third-party-add-info/:clientId"
            element={<AddInfoMultistepThirdParty />}
          />
        </Routes>
      </div>
    )
  );
}

export default App;
